const SHAKER_VARIANT_ID = 55961248203131;

const SHAKER_TRIGGER_VARIANT_IDS = [
  55630202339707,
  54938962559355,
  55946641637755,
  54938959872379,
  56390143836539,
  56356299309435,
  56028953182587,
  56481837482363,
  56481880670587
];

const SHAKER_REMOVED_KEY = "free_shaker_removed";
const SHAKER_PROMO_VALUE = "free_shaker";

function isShakerGiftItem(item) {
  if (!item) return false;

  const hasCorrectVariant =
    Number(item.id) === Number(SHAKER_VARIANT_ID);

  const hasPromoProperty =
    item.properties &&
    item.properties._promo_offer === SHAKER_PROMO_VALUE;

  return hasCorrectVariant || hasPromoProperty;
}

function getShakerGiftItem(cart) {
  if (!cart || !Array.isArray(cart.items)) return null;

  return cart.items.find(item => isShakerGiftItem(item)) || null;
}

function hasShakerTriggerProduct(cart) {
  if (!cart || !Array.isArray(cart.items)) return false;

  return cart.items.some(item =>
    SHAKER_TRIGGER_VARIANT_IDS.includes(Number(item.id))
  );
}

function customerRemovedShaker() {
  return sessionStorage.getItem(SHAKER_REMOVED_KEY) === "true";
}

function markShakerAsRemovedByCustomer() {
  sessionStorage.setItem(SHAKER_REMOVED_KEY, "true");

  console.log(
    "SHAKER: klient ręcznie usunął shaker - ponowny auto-add zablokowany."
  );
}

function resetShakerRemovalState() {
  sessionStorage.removeItem(SHAKER_REMOVED_KEY);
}

async function addShakerGift() {
  try {
    console.log("SHAKER: dodaję shaker...");

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: SHAKER_VARIANT_ID,
            quantity: 1,
            properties: {
              "_promo_offer": SHAKER_PROMO_VALUE
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);

      console.error(
        "SHAKER: Shopify nie dodał shakera:",
        errorData
      );

      return false;
    }

    console.log("SHAKER: shaker został dodany.");

    return true;

  } catch (error) {
    console.error(
      "SHAKER: błąd podczas dodawania:",
      error
    );

    return false;
  }
}

async function removeShakerAutomatically(cart) {
  const shakerItem = getShakerGiftItem(cart);

  if (!shakerItem) return false;

  try {
    console.log(
      "SHAKER: automatycznie usuwam shaker..."
    );

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: shakerItem.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      console.error(
        "SHAKER: nie udało się automatycznie usunąć shakera."
      );

      return false;
    }

    console.log(
      "SHAKER: shaker automatycznie usunięty."
    );

    return true;

  } catch (error) {
    console.error(
      "SHAKER: błąd automatycznego usuwania:",
      error
    );

    return false;
  }
}

async function handleShakerGift(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return cart;
  }

  if (cart.items.length === 0) {
    resetShakerRemovalState();
    return cart;
  }

  const shakerItem = getShakerGiftItem(cart);
  const shakerInCart = !!shakerItem;
  const hasTrigger = hasShakerTriggerProduct(cart);
  const customerRemoved = customerRemovedShaker();

  if (shakerInCart && !hasTrigger) {
    await removeShakerAutomatically(cart);

    const response = await fetch("/cart.js");
    return await response.json();
  }

  if (shakerInCart) {
    return cart;
  }

  if (!hasTrigger) {
    return cart;
  }

  if (customerRemoved) {
    return cart;
  }

  const added = await addShakerGift();

  if (!added) {
    return cart;
  }

  const response = await fetch("/cart.js");

  return await response.json();
}

async function openCartDrawer() {
  const drawer = document.querySelector(".cart-drawer");

  if (!drawer) return;

  drawer.classList.add("cart-drawer--active");

  try {
    const cartResponse = await fetch("/cart.js");

    if (!cartResponse.ok) {
      throw new Error("Nie udało się pobrać koszyka.");
    }

    const cartData = await cartResponse.json();

    if (cartData && cartData.items.length > 0) {
      const cartItems = cartData.items.map(item => ({
        item_id: item.product_id.toString(),

        item_name: item.product_title
          .replace(/'/g, "")
          .replace(/"/g, ""),

        item_brand: item.vendor
          ? item.vendor
              .replace(/'/g, "")
              .replace(/"/g, "")
          : "",

        item_category: item.product_type
          ? item.product_type
              .replace(/'/g, "")
              .replace(/"/g, "")
          : "",

        item_variant: item.sku || "",

        currency: "PLN",

        price: (item.price / 100).toFixed(2),

        quantity: item.quantity
      }));

      const cartValue = cartData.total_price / 100;

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        ecommerce: null
      });

      window.dataLayer.push({
        event: "ee_view_cart",

        ecommerce: {
          currency: "PLN",
          value: cartValue.toFixed(2),
          items: cartItems
        }
      });
    }

  } catch (error) {
    console.error(
      "Error tracking view_cart event:",
      error
    );
  }
}

function closeCartDrawer() {
  const drawer = document.querySelector(".cart-drawer");

  if (!drawer) return;

  drawer.classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document
    .querySelectorAll(".cart-count")
    .forEach(el => {
      el.textContent = count;
    });
}

async function updateCartDrawer() {
  try {
    const blockedVariantIds = [
      55589158977915,
      55936668991867,
      55949052772731,
      50774778085716,
      55941075370363
    ];

    let cartResponse = await fetch("/cart.js");

    if (!cartResponse.ok) {
      throw new Error(
        "Nie udało się pobrać koszyka."
      );
    }

    let cart = await cartResponse.json();

    const updatesToRemove = {};

    cart.items.forEach(item => {
      if (
        blockedVariantIds.includes(Number(item.id))
      ) {
        updatesToRemove[item.key] = 0;
      }
    });

    if (Object.keys(updatesToRemove).length > 0) {
      const removeResponse =
        await fetch("/cart/update.js", {
          method: "POST",

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            updates: updatesToRemove
          })
        });

      if (!removeResponse.ok) {
        const errorData =
          await removeResponse
            .json()
            .catch(() => null);

        console.error(
          "Błąd usuwania zablokowanych produktów:",
          errorData
        );
      }

      cartResponse = await fetch("/cart.js");

      if (!cartResponse.ok) {
        throw new Error(
          "Nie udało się ponownie pobrać koszyka."
        );
      }

      cart = await cartResponse.json();
    }

    // SHAKER - sprawdzenie po każdej zmianie koszyka
    cart = await handleShakerGift(cart);

    updateCartItemCounts(cart.item_count);

    const res =
      await fetch("/?section_id=cart-drawer");

    if (!res.ok) {
      throw new Error(
        "Nie udało się pobrać sekcji cart-drawer."
      );
    }

    const text = await res.text();

    const html =
      document.createElement("div");

    html.innerHTML = text;

    const newDrawer =
      html.querySelector(".cart-drawer");

    const currentDrawer =
      document.querySelector(".cart-drawer");

    if (!newDrawer || !currentDrawer) {
      console.error(
        "Nie znaleziono .cart-drawer podczas aktualizacji."
      );

      return;
    }

    currentDrawer.innerHTML =
      newDrawer.innerHTML;

    addCartDrawerListeners();
    addUpsellListeners();

  } catch (error) {
    console.error(
      "Błąd updateCartDrawer:",
      error
    );
  }
}

function addCartDrawerListeners() {
  document
    .querySelectorAll(
      ".cart-drawer-quantity-selector button"
    )
    .forEach(button => {
      button.addEventListener(
        "click",
        async e => {
          e.preventDefault();
          e.stopPropagation();

          if (button.disabled) return;

          const rootItem =
            button.closest(
              "[data-line-item-key]"
            );

          if (!rootItem) {
            console.error(
              "QUANTITY: brak [data-line-item-key]"
            );
            return;
          }

          const key =
            rootItem.getAttribute(
              "data-line-item-key"
            );

          if (!key) {
            console.error(
              "QUANTITY: brak line item key"
            );
            return;
          }

          const input =
            button.parentElement
              .querySelector("input");

          if (!input) {
            console.error(
              "QUANTITY: brak input quantity"
            );
            return;
          }

          const currentQuantity =
            Number(input.value);

          const isUp =
            button.classList.contains(
              "cart-drawer-quantity-selector-plus"
            );

          const newQuantity =
            isUp
              ? currentQuantity + 1
              : currentQuantity - 1;

          // Pobieramy item, żeby rozpoznać shaker
          const cartBefore =
            await fetch("/cart.js")
              .then(r => r.json());

          const currentItem =
            cartBefore.items.find(
              item => item.key === key
            );

          // Klient ręcznie usuwa shaker
          if (
            currentItem &&
            isShakerGiftItem(currentItem) &&
            newQuantity <= 0
          ) {
            markShakerAsRemovedByCustomer();
          }

          // Shaker maksymalnie 1 szt.
          if (
            currentItem &&
            isShakerGiftItem(currentItem) &&
            newQuantity > 1
          ) {
            alert(
              "Shaker promocyjny można dodać tylko w 1 sztuce."
            );

            return;
          }

          const productId =
            Number(
              rootItem.getAttribute(
                "data-product-id"
              )
            );

          const problematicId =
            50774778085716;

          if (
            productId === problematicId &&
            newQuantity > 1
          ) {
            alert(
              "Tego produktu nie można dodać więcej niż 1 raz."
            );

            return;
          }

          button.disabled = true;

          try {
            const res =
              await fetch(
                "/cart/change.js",
                {
                  method: "POST",

                  headers: {
                    Accept:
                      "application/json",

                    "Content-Type":
                      "application/json"
                  },

                  body:
                    JSON.stringify({
                      id: key,

                      quantity:
                        Math.max(
                          newQuantity,
                          0
                        )
                    })
                }
              );

            if (!res.ok) {
              const errorData =
                await res
                  .json()
                  .catch(() => null);

              console.error(
                "QUANTITY: Shopify zwrócił błąd:",
                errorData
              );

              return;
            }

            const cart =
              await res.json();

            updateCartItemCounts(
              cart.item_count
            );

            await updateCartDrawer();

          } catch (error) {
            console.error(
              "QUANTITY: błąd zmiany ilości:",
              error
            );

          } finally {
            if (
              document.body.contains(button)
            ) {
              button.disabled = false;
            }
          }
        }
      );
    });

  document
    .querySelectorAll(
      ".cart-drawer-remove-button"
    )
    .forEach(button => {
      button.addEventListener(
        "click",
        async e => {
          e.preventDefault();
          e.stopPropagation();

          if (button.disabled) {
            return;
          }

          const rootItem =
            button.closest(
              "[data-line-item-key]"
            );

          if (!rootItem) {
            console.error(
              "REMOVE: nie znaleziono [data-line-item-key]"
            );
            return;
          }

          const key =
            rootItem.getAttribute(
              "data-line-item-key"
            );

          if (!key) {
            console.error(
              "REMOVE: brak line item key"
            );
            return;
          }

          const cartBefore =
            await fetch("/cart.js")
              .then(r => r.json());

          const itemToRemove =
            cartBefore.items.find(
              item => item.key === key
            );

          // Klient ręcznie usuwa shaker
          if (
            itemToRemove &&
            isShakerGiftItem(itemToRemove)
          ) {
            markShakerAsRemovedByCustomer();
          }

          button.disabled = true;

          button.classList.add(
            "is-loading"
          );

          try {
            const res =
              await fetch(
                "/cart/change.js",
                {
                  method: "POST",

                  headers: {
                    Accept:
                      "application/json",

                    "Content-Type":
                      "application/json"
                  },

                  body:
                    JSON.stringify({
                      id: key,
                      quantity: 0
                    })
                }
              );

            if (!res.ok) {
              const errorData =
                await res
                  .json()
                  .catch(() => null);

              console.error(
                "REMOVE: Shopify zwrócił błąd:",
                errorData
              );

              throw new Error(
                "Nie udało się usunąć produktu."
              );
            }

            const cart =
              await res.json();

            updateCartItemCounts(
              cart.item_count
            );

            await updateCartDrawer();

          } catch (error) {
            console.error(
              "REMOVE: błąd usuwania:",
              error
            );

          } finally {
            if (
              document.body.contains(button)
            ) {
              button.disabled = false;

              button.classList.remove(
                "is-loading"
              );
            }
          }
        }
      );
    });

  const drawerBox =
    document.querySelector(
      ".cart-drawer-box"
    );

  if (drawerBox) {
    drawerBox.addEventListener(
      "click",
      e => {
        e.stopPropagation();
      }
    );
  }

  document
    .querySelectorAll(
      ".cart-drawer-header-right-close, .cart-drawer, .cart-drawer-button--continue"
    )
    .forEach(el => {
      el.addEventListener(
        "click",
        () => {
          closeCartDrawer();
        }
      );
    });
}

addCartDrawerListeners();

document
  .querySelectorAll(
    'form[action="/cart/add"]'
  )
  .forEach(form => {
    form.addEventListener(
      "submit",
      async e => {
        e.preventDefault();

        try {
          const discount =
            form.querySelector(
              ".discount"
            );

          if (discount) {
            await fetch(
              "/discount/" +
              discount.value
            );
          }

          const cartRes =
            await fetch("/cart.js");

          if (!cartRes.ok) {
            throw new Error(
              "Nie udało się pobrać koszyka."
            );
          }

          const cartData =
            await cartRes.json();

          const formData =
            new FormData(form);

          const incomingId =
            parseInt(
              formData.get("id")
            );

          const problematicId =
            50774778085716;

          const isOnlyProduct =
            cartData.items.length === 0 &&
            incomingId === problematicId;

          const alreadyExists =
            cartData.items.some(
              item =>
                Number(item.id) ===
                problematicId
            );

          if (isOnlyProduct) {
            alert(
              "Ten produkt musi być kupowany z innym produktem."
            );

            return;
          }

          if (
            alreadyExists &&
            incomingId === problematicId
          ) {
            alert(
              "Tego produktu nie można dodać więcej niż 1 raz."
            );

            return;
          }

          const addResponse =
            await fetch(
              "/cart/add",
              {
                method: "POST",
                body: formData
              }
            );

          if (!addResponse.ok) {
            throw new Error(
              "Nie udało się dodać produktu."
            );
          }

          const res =
            await fetch("/cart.js");

          if (!res.ok) {
            throw new Error(
              "Nie udało się odświeżyć koszyka."
            );
          }

          const cart =
            await res.json();

          updateCartItemCounts(
            cart.item_count
          );

          // tutaj updateCartDrawer automatycznie
          // doda shaker jeśli produkt się kwalifikuje
          await updateCartDrawer();

          openCartDrawer();

        } catch (error) {
          console.error(
            "ADD TO CART ERROR:",
            error
          );
        }
      }
    );
  });

function addUpsellListeners() {
  document
    .querySelectorAll(
      ".upsell_button"
    )
    .forEach(button => {
      button.setAttribute(
        "type",
        "button"
      );

      button.addEventListener(
        "touchstart",
        () => {},
        {
          passive: true
        }
      );

      button.addEventListener(
        "click",
        async e => {
          e.preventDefault();
          e.stopPropagation();

          if (button.disabled) {
            return;
          }

          const idMap = {
            upsell_btn1: 55630202339707,
            upsell_btn2: 41305381241041,
            upsell_btn3: 48011715739988,
            upsell_btn4: 41305382518993,
            upsell_btn5: 55240395850107,
            upsell_btn6: 54938962559355,
            upsell_btn7: 54938959872379,
            upsell_btn8: 48011743035732,
            upsell_btn9: 55886102036859,
            upsell_btn10: 55910122455419,
            upsell_btn11: 55589158977915,
            upsell_btn12: 55936668991867,
            upsell_btn13: 50774778085716,
            upsell_btn14: 55949052772731,
            upsell_btn15: 55924567310715,
            upsell_btn16: 55946641637755,
            upsell_btn17: 49790156341588,
            upsell_btn18: 49765921751380,
            upsell_btn19: 49790152048980,
            upsell_btn20: 55964446949755,
            upsell_btn21: 55964461629819,
            upsell_btn22: 55964467691899,
            upsell_btn23: 55940874568059,
            upsell_btn24: 55924573307259,
            upsell_btn25: 41305381175505
          };

          const productId =
            idMap[e.currentTarget.id];

          if (!productId) {
            return;
          }

          button.disabled = true;

          const formData = {
            items: [
              {
                id: productId,
                quantity: 1
              }
            ]
          };

          try {
            const addResponse =
              await fetch(
                "/cart/add.js",
                {
                  method: "POST",

                  headers: {
                    "Content-Type":
                      "application/json",

                    Accept:
                      "application/json"
                  },

                  body:
                    JSON.stringify(
                      formData
                    )
                }
              );

            if (!addResponse.ok) {
              const errorData =
                await addResponse
                  .json()
                  .catch(() => null);

              console.error(
                "UPSELL: Shopify zwrócił błąd:",
                errorData
              );

              return;
            }

            const res =
              await fetch("/cart.js");

            if (!res.ok) {
              throw new Error(
                "Nie udało się odświeżyć koszyka."
              );
            }

            const cart =
              await res.json();

            updateCartItemCounts(
              cart.item_count
            );

            // także po dodaniu produktu z upsellu
            // sprawdzamy, czy należy dodać shaker
            await updateCartDrawer();

          } catch (error) {
            console.error(
              "Błąd podczas dodawania upsell:",
              error
            );

          } finally {
            if (
              document.body.contains(button)
            ) {
              button.disabled = false;
            }
          }
        }
      );
    });
}

addUpsellListeners();

updateCartDrawer();

document
  .querySelectorAll(
    'a[href="/cart"]'
  )
  .forEach(a => {
    a.addEventListener(
      "click",
      e => {
        e.preventDefault();

        openCartDrawer();
      }
    );
  });